<template>
  <div>
    <template v-if="media">
      <ul class="image-list flex wrap">
        <template v-for="(image, index) in media">
          <li class="image-item" :key="index">
            <input type="radio" :id="_uid + '-' + image.id" class="image-item-input" v-model="selected.id" :value="image.id" />
            <label :for="_uid + '-' + image.id" class="image-item-label">
              <img class="image" :src="image.media_details.sizes.thumbnail.source_url" />
            </label>
          </li>
        </template>
      </ul>
    </template>
  </div>
</template>

<script>
export default {
  name: 'select-image',
  props: ['value'],
  data: function () {
    return {
      selected: {id: 0}
    }
  },
  // watch: {
  //   /**
  //    * @see https://stackoverflow.com/questions/40915436/vuejs-update-parent-data-from-child-component/40915910
  //    */
  //   selected: function (newVal, oldVal) {
  //     console.log('%cnewValue = ' + JSON.stringify(newVal), 'color:red')
  //     console.log('%coldValue = ' + JSON.stringify(oldVal), 'color:red')
  //     this.selected.id = newVal.id
  //     this.$emit('input', this.selected)
  //   }
  // },
  computed: {
    media: {
      get () { return this.$store.getters['wordpress/media/all'] }
    }
  },
  created: function () {
    if (process.env.NODE_ENV !== 'production') console.log('On SelectImage created...')
    // if (process.env.NODE_ENV !== 'production') console.log(this.media)
    // if (process.env.NODE_ENV !== 'production') console.log(this.media.map(image => image.id))
    // if (process.env.NODE_ENV !== 'production') console.log(this.media.map(image => image.media_details.sizes.thumbnail))

    this.selected = this.value
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  &-list {
    border: 1px solid #ddd;
    height: 180px;
    min-height: 50vh;
    overflow: scroll;
  }
  &-item {
    &-input {
      display: none;
      &:checked + .image-item-label:after {
        border: 3px solid $--color-primary;
      }
    }
    &-label {
      display: block;
      width: 139px;
      height: 139px;
      position: relative;
      &:after {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
}
</style>


<doc>
# 画像IDを含むオブジェクトをv-modelで渡し、メディアから選択した画像のIDで書き換えて返すコンポーネント

```
<select-image v-model="selectedImage" @change="onUpdateImage"></select-image>
```
</doc>


// WEBPACK FOOTER //
// src/components/app/SelectImage.vue